'use strict';

document.addEventListener('DOMContentLoaded', function() {

  /**
   * パラメータ取得関数
   * URLのクエリ文字列から指定されたパラメータ名に対応する値を取得します。
   * @param {string} name 取得したいパラメータ名
   * @param {string} url 別ページのURLを使用したい場合
   * @returns {string|null} パラメータの値、またはパラメータが存在しない場合はnull
   */
  function getParam(name, url = window.location.search) {
    const params = new URLSearchParams(url);
    const value = params.get(name);
    return value ? sanitizeUrl(value) : null;
  }


  /**
   * エスケープ関数
   * HTMLエスケープ処理を行うための関数です。
   * @param {string} input エスケープしたい文字列
   * @returns {string} エスケープ処理後の文字列
   */
  function sanitizeUrl(input) {
    if (typeof input !== 'string') {
      throw new TypeError('Expected a string');
    }
    return input.replace(/[&'"<>]/g, function(match) {
      return {
        '&': '&amp;',
        "'": '&#x27;',
        '"': '&quot;',
        '<': '&lt;',
        '>': '&gt;',
      }[match];
    });
  }


  /**
   * アンカースクロール
   * @variable headerElement 固定ヘッダーセレクタ
   * @variable headerElement スクロール速度
   */
  const headerClass = '.index-header';

  let scroll = new SmoothScroll('a[href*="#"]', {
    speedAsDuration: true,
    speed: 500,
    header: headerClass,
    easing: 'easeInOutQuint'
  });

  // ページ表示時のアンカー位置にヘッダーの高さを考慮する
  const headerElement = document.querySelector(headerClass);
  let headerElementHeight = 0;

  // ロード時にヘッダーが存在していれば高さを取得
  if ( headerElement !== null ) {
    headerElementHeight = headerElement.offsetHeight;
  }
  // ハッシュ値があればロード時に高さを考慮した位置へスクロール位置を差し替え
  if ( window.location.hash !== '' ) {
    window.addEventListener('load', function() {
      const target = document.querySelector(window.location.hash);
      if ( target !== null ) {
        const position = target.offsetTop - headerElementHeight;
        document.documentElement.scrollTop = position;
      }
    });
  }


  /**
   * アクセシビリティを考慮したスライダー
   * https://ja.splidejs.com/
   */
  /*
  <div class="splide js-slider" aria-label="screen-read-name">
    <div class="splide__track">
      <ul class="splide__list">
        <li class="splide__slide"></li>
      </ul>
    </div>
    <div class="splide__arrows">
      <button class="splide__arrow splide__arrow--prev">Prev</button>
      <ul class="splide__pagination"></ul>
      <button class="splide__arrow splide__arrow--next">Next</button>
    </div>
  </div>
  */
  if ( document.querySelector('.js-slider') !== null ) {
    let jsSlider = new Splide('.js-slider', {
      perPage       : 1,      // 1ページの表示数
      perMove       : 1,      // 1度にスライドを何枚移動するか
      speed         : 800,    // 移動時間（ミリ秒単位）
      type          : 'loop', // ループする場合
      // interval      : 4000,   // 自動再生の間隔（ミリ秒単位）
      // pauseOnHover  : false,  // マウスホバー時に自動再生をストップさせない
      // resetProgress : false,  // 自動再生ストップ時、経過時間を破棄せず続行する
      updateOnMove  : true,   // is-activeクラスを移動前に更新する
      // gap           : '30px', // スライド間の余白（cssと同様）
      // padding       : '50px', // 左右の見切れる幅（cssと同様）
      easing        : 'cubic-bezier(0.25, 1, 0.5, 1)', // 移動アニメーション
      focus         : 'center',

      classes: {
        pagination: "splide__pagination slider-pagination",
        page: "splide__pagination slider-page",
      },

      // インビュー時から自動再生をスタート（拡張機能：splide-extension-intersection.js）
      // autoplay: 'pause',
      // intersection: {
      //   inView: {
      //     autoplay: true,
      //   },
      //   outView: {
      //     autoplay: false,
      //   },
      //   once: true, // 一度画面に表示されたら監視を停止する
      // },

      // 動き続けるスライダーを実装（拡張機能：splide-extension-auto-scroll.js）
      // autoScroll: {
      //   speed: 1, // 負の値で流れる向きが右へ変更
      //   pauseOnHover: false,
      //   pauseOnFocus: false,
      // },

      // メディアクエリ設定（初期：751px以上の場合、スライダーを動作させない）
      // mediaQuery: 'min',
      // breakpoints: {
      //   751: {
      //     destroy: true,
      //   },
      // },
    });

    // スライダーに過不足がある場合にスライダーUIを停止・排除する
    jsSlider.on('overflow', function ( isOverflow ) {
      jsSlider.go(0);
      jsSlider.options = {
        arrows    : isOverflow,
        pagination: isOverflow,
        drag      : isOverflow,
        clones    : isOverflow ? undefined : 0,
      };
    } );

    // スライダーを実行
    jsSlider.mount();
    // jsSlider.mount(window.splide.Extensions);

  }


});

// ドロワー
const drawerButton = document.getElementById('js-drawer-button');
const drawer = document.getElementById('js-drawer');
const drawerLink = document.getElementById('js-focus-return');


drawerButton.addEventListener('click', function () {
  drawerButton.classList.toggle('is-open');
  drawer.classList.toggle('is-open');

  if (drawerButton.classList.contains('is-open')) {
    drawerButton.ariaExpanded = true;

    document.getElementById('js-focus-bottom').addEventListener('focus', function () {
      drawerButton.focus();
    });

    document.getElementById('js-focus-top').addEventListener('focus', function () {
      drawerLink.focus();
    });
  } else {
    drawerButton.ariaExpanded = false;
  }
});

const drawerLinkAnchor = drawer.querySelectorAll('a[href^="/"]');

drawerLinkAnchor.forEach(function (link) {
  link.addEventListener('click', function() {
    if(drawer.classList.contains('is-open')) {
      drawerButton.classList.remove('is-open');
      drawer.classList.remove('is-open');
    }
  })
});


$('.js-drawer-button').on('click', function () {
  
  var $parent = $(this).parent();
  var $subList = $parent.next('.l-drawer_sublists');

  $subList.toggleClass('is-show').slideToggle(300);
  $(this).toggleClass('is-show');

  if($(this).hasClass('is-show')) {
    $(this).attr('aria-expanded', 'true');
  } else {
    $(this).attr('aria-expanded', 'false');
  }
});


//escキー押下でメニューを閉じる
document.addEventListener('keydown', function(e) {　
  if (e.key === 'Escape') {
    drawerButton.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawerButton.focus();
    drawerButton.ariaExpanded = false;
  }
});


// ヘッダー
function indexHeader() {
  let windowWidth = window.innerWidth;
    let windowHeight = $('.index-mainvisual').height() + $('#js-header').height();

  if (windowWidth > 1030) {
    if (830 < $(window).scrollTop()) {
      $('#js-header').fadeIn(300);
      $('#js-header').addClass("is-show");
      $('#js-header').css("display", "flex");
    } else {
      $('#js-header').fadeOut(300);
      $('#js-header').removeClass("is-show");
      $('#js-header').css("display", "none");
    }
  } else {
    $('#js-header').fadeIn(300);
    $('#js-header').addClass("is-show");
    $('#js-header').css("display", "flex");
  }
};

$(function () {
  if( location.pathname === '/' ) {
    indexHeader();

    $(window).on('resize scroll', function () {
      indexHeader();
    });
  }
});

// 下層ページヘッダー
function marginTop() {
  let headerHeight = $('#js-header').height();
  $('.m-pageheader').css('marginTop', headerHeight + 'px');
};

$(function () {
  marginTop();

  window.onresize = function() {
    marginTop();
  }
});

// ページトップ
const pageTop = document.getElementById("js-pagetop");

let lastScrollTop = 0;

window.addEventListener("scroll", function () {
  let currentScrollTop = window.scrollY;

  if (currentScrollTop > 400 && currentScrollTop > lastScrollTop) {
    pageTop.classList.add("is-show");
    
  } else {
    pageTop.classList.remove("is-show");
  }

  lastScrollTop = currentScrollTop;
});

// Lecture アコーディオン
$('.lecture-contents_head').on('click', function () {
  $(this).next('.lecture-contents_body').slideToggle(300);
  $(this).toggleClass('is-open');
  $(this).parents('.lecture-contents').toggleClass('is-open');

  if($(this).hasClass('is-open')) {
    $(this).attr('aria-expanded', 'true');
  } else {
    $(this).attr('aria-expanded', 'false');
  }
});